import { render, staticRenderFns } from "./UploadTransactionTable.vue?vue&type=template&id=564d968a&lang=pug"
import script from "./UploadTransactionTable.vue?vue&type=script&lang=js"
export * from "./UploadTransactionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports